export const MODULE_DEF = {
    'default': ()=>{
        return () =>  import('../modules/default/default.module').then(m => m.DefaultModule)
    }
}